module.exports = __webpack_public_path__ + "img/header-pdf.04008f94.jpg";